import { useState } from "react";
import "./soluctions_card.css";
import { FaArrowRight } from "react-icons/fa6";
import { scrollToSectionUtils } from "../../../utils/scroll_to_section_ultils.jsx";

const SoluctionsCards = ({ title_front, description_front, image, title_back, description_back }) => {
    const [isFlipped, setIsFlipped] = useState(false);

    const handleFlip = () => {
        setIsFlipped(!isFlipped);
    };

    const scrollToContact = () => {
        scrollToSectionUtils('contato');
    };

    return (
        <div className={`soluctions_card`}>
            <div className={`card ${isFlipped ? "flipped" : ""}`} onClick={handleFlip}>
                <div className="flip_card_front">
                    <div className="image">
                        <img src={image} alt={title_front} />
                    </div>
                    <div className="info-card">
                        <div className="info-card-content">
                            <div className="title">
                                <h1>{title_front}</h1>
                            </div>
                            <div className="description">
                                <h2>{description_front}</h2>
                            </div>
                        </div>
                        <div className="button">
                            <div className="row">
                                <div className="col-11 learn_more" onClick={handleFlip} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleFlip(); }}>
                                    <p>Saiba mais</p>
                                </div>
                                <div className="col-1 icon" onClick={handleFlip} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleFlip(); }}>
                                    <FaArrowRight />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flip_card_back">
                    <div className="info-card">
                        <div className="info-card-content">
                            <div className="title">
                                <h1>{title_back}</h1>
                            </div>
                            <div className="description">
                                <h2>{description_back}</h2>
                            </div>
                        </div>
                        <div className="button">
                            <div className="row">
                                <div className="col-11 learn_more button_back" onClick={(e) => { e.stopPropagation(); scrollToContact(); }} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToContact(); } }}>
                                    <p>Entrar em contato</p>
                                </div>
                                <div className="col-1 icon" onClick={(e) => { e.stopPropagation(); scrollToContact(); }} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToContact(); } }}>
                                    <FaArrowRight />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SoluctionsCards;
